<script>
import {mapGetters} from "vuex";
import trinkwasserHeader from "@/assets/trinkwasser_header.jpg";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
export default {
  name: "TrinkwasserView",
  components: {Breadcrumbs, RightColumnGroup},
  data: () => ({
    header: trinkwasserHeader,
  }),
  computed: {
    ...mapGetters('user', ['userCommunePartner', 'userCommuneRegionalLeader', "userCommuneName", "getDashboardCommunePartners"]),
    hideServices() {
      const communes = ["Brüggen", "Erkelenz", "Gangelt", "Geilenkirchen", "Hückelhoven", "Niederkrüchten", "Schwalmtal", "Selfkant", "Übach-Palenberg", "Waldfeucht", "Wassenberg"];

      return communes.includes(this.userCommuneName);
    },
    sidebarConfig() {
      return {
        showRegionalLeiter: false,
        personsInCharge: this.getDashboardCommunePartners,
        interestingLinks: [
          { id: 0, title: "Trinkwasser für die Region ", link: "https://www.new.de/trinkwasser" },
          !this.hideServices ? { id: 1, title: "Hinweise für die Versorgung von öffentl. Veranstaltungen ", link: "https://assets.ctfassets.net/vqectq7bwu5c/5vs3DmI58mQDqWOV6NoTC7/1e71d19b522694007b15f62cc1c8c345/250709_NEW_Trinkw-Volksfest_Merkblatt_mitLogo_barrierearm.pdf?search=trinkwasser+f%C3%BCr+veran" } : null
        ].filter(link => link !== null)
      }
    },
    text() {
      if(this.hideServices) {
        return `<p>
            Zum Kerngeschäft der NEW-Gruppe gehört die zuverlässige Versorgung der Kommunen mit Trinkwasser. Wasser kommt aus dem Wasserhahn. Aber wie kommt es eigentlich in die Leitung? Und warum ist es so sauber, dass Sie ohne Bedenken einfach einen großen Schluck Heimat trinken können? Wir erklären Ihnen alles zum Grundwasser und wie das zu Ihrem Trinkwasser wird. <br><br>
            Alles beginnt mit der Aufbereitung unseres örtlichen Grundwassers in gesundes Trinkwasser. Hierzu entziehen wir dem sogenannten Rohwasser überschüssige Kohlensäure. Eisen sowie Mangan filtern wir sorgfältig heraus. Eine Chlorung führen wir nur bei Bedarf durch. Um die einwandfreie Qualität unseres Wassers sicherzustellen, lässt die NEW regelmäßig und sorgfältig Kontrollen durchführen. Grenz- und Vorsorgewerte der Trinkwasserverordnung werden genau überprüft – für ein sicheres Trinkerlebnis. <br><br>
            Kurz und knapp: Mit wenigen Aufbereitungsschritten sorgen unsere Mitarbeiter:innen an 365 Tagen im Jahr für Ihre gesunde Trinkwasserversorgung. <br><br>
            Effizient, regional, partnerschaftlich - so führt die NEW Netz GmbH das Trinkwassernetz in ihrem Versorgungsgebiet.
        </p>`
      }

      return `
          <p class="font-weight-bold">Sichere Trinkwasserversorgung für die Kommunen</p>
          <p>
          Zum Kerngeschäft der NEW-Gruppe gehört die zuverlässige Versorgung der Kommunen mit Trinkwasser. Wasser kommt aus dem Wasserhahn. Aber wie kommt es eigentlich in die Leitung? Und warum ist es so sauber, dass Sie ohne Bedenken einfach einen großen Schluck Heimat trinken können? Wir erklären Ihnen alles zum Grundwasser und wie das zu Ihrem Trinkwasser wird. <br><br>
            Alles beginnt mit der Aufbereitung unseres örtlichen Grundwassers in gesundes Trinkwasser. Hierzu entziehen wir dem sogenannten Rohwasser überschüssige Kohlensäure. Eisen sowie Mangan filtern wir sorgfältig heraus. Eine Chlorung führen wir nur bei Bedarf durch. Um die einwandfreie Qualität unseres Wassers sicherzustellen, lässt die NEW regelmäßig und sorgfältig Kontrollen durchführen. Grenz- und Vorsorgewerte der Trinkwasserverordnung werden genau überprüft – für ein sicheres Trinkerlebnis. <br><br>
            Kurz und knapp: Mit wenigen Aufbereitungsschritten sorgen unsere Mitarbeiter:innen an 365 Tagen im Jahr für Ihre gesunde Trinkwasserversorgung. <br><br>
            Effizient, regional, partnerschaftlich - so führt die NEW Netz GmbH das Trinkwassernetz in ihrem Versorgungsgebiet.
        </p>
          <p class="font-weight-bold">Standrohrausgabe</p>
          <p>
          Wenn Sie eine Baustelle oder eine Veranstaltung mit Trinkwasser versorgen müssen, benötigen Sie ein Standrohr. Das Standrohr wird auf einen Hydranten montiert und ermöglicht Ihnen somit, Trinkwasser aus dem Versorgungsnetz der NEW zu entnehmen (Hydranten sind im Netz fest eingebaute Entnahmestellen). Am Standrohr sind ein oder mehrere Zapfhähne mit einer Sicherungseinrichtung angebracht. Diese verhindert, dass Wasser aus Ihrer Anlage zurück in das Versorgungsnetz strömen kann. Sie als Standrohrmieter:in sind neben der allgemeinen Verkehrssicherungspflicht auch für die ordnungsgemäße Installation des Verteilungsnetzes ab dem Standrohr zuständig. Hierzu verweisen wir auf das Infoblatt im Downloadbereich (siehe unten) und auf die gesetzlichen Vorgaben wie STVO oder RSA. <br><br>
          Zur Absicherung des Aufstellbereiches des Standrohres haben Sie die Möglichkeit, entsprechendes Absperrmaterial bei der NEW auszuleihen. Nicht jeder Hydrant im Versorgungsnetz ist für die Montage eines Standrohres geeignet. Teilen Sie unserem Standrohrservice-Team bitte mit, wo Sie das Standrohr einsetzen möchten. Sie erhalten dann einen Plan, worauf ein geeigneter Hydrant gekennzeichnet ist. <br><br>
          Voraussetzungen Die Ausgabe eines Standrohres ist an folgende Voraussetzungen geknüpft, auf deren Erfüllung wir bestehen müssen: <br><br>
          Zahlung der Sicherheitssumme von 500,- EUR mit EC-Karte mit PIN Nummer, Bar, Verrechnungsscheck Bauherrenhaftpflicht-, Betriebshaftpflicht- oder Veranstalterhaftpflichtversicherung Benutzungsentgelte Für die Nutzung des Standrohres und die Entnahme von Trinkwasser aus dem Versorgungsnetz der NEW sind in der jeweiligen Stadt oder Gemeinde Entgelte zu zahlen. Bitte jeweils erfragen! <br><br>
          Die entnommene Wassermenge ist mit dem jeweils gültigen Wasserpreis gemäß AVBWasserV zu vergüten. Weitere Hinweise zum Standrohrmiet- und Trinkwasserlieferungsvertrag finden Sie im Downloadbereich (siehe unten). <br><br>
          Standrohrausgabe Unser Standrohrservice-Team steht Ihnen unter der 02451 624-3809 bzw. -3807 oder standrohr@new.de zur Verfügung. Die Standrohrausgabe bzw. Rückgabe erfolgt auf der Voltastraße 2, (Gebäude 5) in Mönchengladbach, zu folgenden Öffnungszeiten: <br><br>
          Montag - Donnerstag 08:00 bis 12:00 Uhr und 13:00 bis 16:00 Uhr Freitag 08:00 bis 12:30 Uhr <br><br>
          Bitte haben Sie Verständnis dafür, dass wir für die Befüllung von Schwimmbecken oder Gartenteichen keine Standrohre ausgeben!
            </p>


      `;
    }
  }
}
</script>

<template>
  <div class="trinkwasser-view min-height-100">
    <v-img
        :src="header"
        aspect-ratio="2.1333"
        max-height="450px"
        class="trinkwasser-header"
    >
      <span
          class="custom-header-text new-font-bold white--text"
          style="position: absolute; bottom: 20px; left: 35px;"
      >
        Trinkwasser
      </span>
    </v-img>
    <v-row no-gutters class="trinkwasser-content">
      <v-col cols="12" sm="8" class="new-wrapper px-10 py-4">
        <breadcrumbs />
        <div v-html="text"></div>
      </v-col>
      <v-col
          cols="12"
          sm="4"
          class="contact_container pl-4"
      >
        <RightColumnGroup
            :communePartner="userCommunePartner"
            :communeRegionalLeader="userCommuneRegionalLeader"
            :contentObject="sidebarConfig"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.trinkwasser-view {
  display: flex;
  flex-direction: column;
}

.trinkwasser-header {
  flex-shrink: 0;
}

.trinkwasser-content {
  flex: 1;
}
</style>
